// extracted by mini-css-extract-plugin
module.exports = {"lia-terms-of-service-container":"TermsOfServiceWidget_lia-terms-of-service-container__s_zUI"};